<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="miniSidebar"
      color="orange lighten-1"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      class="sidebar"
    >
      <v-list class="nav-list" dense>
        <template v-for="item in filterMenu(menuItems)">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children && $can(item.permission)"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item['icon-alt']"
            append-icon="mdi-menu-down"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-for="(child, i) in item.children">
              <v-list-item
                v-if="$can(child.permission)"
                :key="i"
                link
                :to="child.link"
                class="sidechild"
              >
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ child.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-group>
          <v-list-item
            v-else-if="$can(item.permission)"
            :key="item.text"
            link
            :to="item.link"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    source: String,
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    ...mapGetters({
      drawerSidebar: 'global/getDrawerSidebar',
      role: 'global/getRole',
    }),
    drawer: {
      get() {
        return this.$store.getters['global/getDrawerSidebar'];
      },
      set(value) {
        this.$store.commit('global/setDrawerSidebar', value);
      },
    },
    miniSidebar: {
      get() {
        return this.$store.getters['global/getMiniSidebar'];
      },
      set(value) {
        this.$store.commit('global/setMiniSidebar', value);
      },
    },
    menuItems() {
      const items = [
        {
          icon: 'mdi-clipboard-text',
          text: this.$t('workersList.title'),
          model: true,
          link: '/workers-board',
          permission: 'workdesk_view',
        },
        {
          icon: 'mdi-deskphone',
          text: this.$t('investorList.title'),
          model: true,
          link: '/investor-board',
          onlyFor: 'investor',
        },
        {
          icon: 'mdi-car',
          text: this.$t('sidebar.autos'),
          model: true,
          link: '/investor-auto',
          onlyFor: 'investor',
          permission: 'investor_car_view',
        },
        {
          icon: 'mdi-car-multiple',
          text: this.$t('dtp.title'),
          model: true,
          link: '/investor-dtp/investor-dtp-list',
          onlyFor: 'investor',
          permission: 'investor_car_accident_view',
        },
        {
          icon: 'mdi-handshake',
          text: this.$t('sidebar.rent'),
          model: true,
          link: '/rents/rents-list',
          permission: 'rent_view',
        },
        {
          icon: 'mdi-percent',
          text: this.$t('rates.title'),
          model: true,
          link: '/rates/rates-list',
          permission: 'rent_rate_view',
        },
        {
          icon: 'mdi-calendar-weekend',
          text: this.$t('weekendScheldule.title'),
          model: true,
          link: '/weekend-schedule/weekend-schedule-list',
          permission: 'weekend_schedule_view',
        },
        {
          icon: 'mdi-calendar-month',
          text: this.$t('sidebar.bookings'),
          model: true,
          link: '/bookings/bookings-list',
          permission: 'book_view',
        },
        {
          icon: 'mdi-car',
          text: this.$t('sidebar.autos'),
          model: true,
          link: '/autos/autos-list',
          permission: 'car_view',
        },
        {
          icon: 'mdi-contacts',
          text: this.$t('sidebar.drivers'),
          model: true,
          link: '/drivers/drivers-list',
          permission: 'driver_view',
        },
        {
          icon: 'mdi-account-cash',
          text: this.$t('sidebar.investors'),
          model: true,
          link: '/investors/investors-list',
          permission: 'investor_view',
        },
        {
          icon: 'mdi-cash-multiple',
          text: this.$t('investor-report.title'),
          model: true,
          link: '/investor-report/investor-report-list',
          permission: 'investor_report_view',
        },
        {
          icon: 'mdi-truck',
          text: this.$t('suppliers.title'),
          model: true,
          link: '/suppliers/suppliers-list',
          permission: 'supplier_view',
        },
        {
          icon: 'mdi-account-multiple',
          text: this.$t('employees.title'),
          model: true,
          link: '/employees/employees-list',
          permission: 'employee_view',
        },
        {
          icon: 'mdi-account-cog',
          text: this.$t('roles.title'),
          model: true,
          link: '/roles/roles-list',
          permission: 'role_view',
        },
        {
          icon: 'mdi-garage-variant',
          text: this.$t('parks.title'),
          model: true,
          link: '/parks/parks-list',
          permission: 'car_park_view',
        },
        {
          icon: 'mdi-cash-remove',
          text: this.$t('fines.title'),
          model: true,
          link: '/fines/fines-list',
          permission: 'fines_view',
        },
        {
          icon: 'mdi-cash-remove',
          text: this.$t('fines.title_2'),
          model: true,
          link: '/fines/fines-list-v2',
          permission: 'fines_view',
        },
        {
          icon: 'mdi-car-multiple',
          text: this.$t('dtp.title'),
          model: true,
          link: '/dtp/dtp-list',
          permission: 'car_accident_view',
        },
        {
          icon: 'mdi-twitch',
          text: this.$t('appeals.appeals'),
          model: true,
          link: '/appeals/appeals-list',
          permission: 'appeals',
        },
        // {
        //   icon: 'mdi-car-key',
        //   text: this.$t('mechanic.rents.title'),
        //   model: true,
        //   permission: '',
        //   link: 'mechanic/rents',
        //   onlyFor: 'mechanic',
        // },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-finance',
          text: this.$t('finance.title'),
          permission: 'finance_view',
          children: [
            {
              icon: 'mdi-cash-minus',
              text: this.$t('finance.сompanyExpenses'),
              model: true,
              link: '/finance/company-expenses',
              permission: 'finance_expanse_view',
            },
          ],
        },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-cog',
          text: this.$t('sidebar.settings'),
          permission: 'settings_view',
          children: [
            {
              icon: 'mdi-home-city',
              text: this.$t('sidebar.companies'),
              model: true,
              link: '/settings/companies',
              permission: 'company_view',
            },
          ],
        },
      ];
      return items;
    },
  },
  methods: {
    filterMenu(items) {
      // eslint-disable-next-line
      return items.filter(({ onlyFor }) => {
        if (!onlyFor) return true;
        return this.role === onlyFor;
      });
    },
    isItemActive(link) {
      return this.$route.path === link;
    },
  },
};
</script>

<style lang="scss">
.sidebar {
  top: 48px !important;

  .nav-list {
    height: calc(100vh - 48px);
    overflow-y: auto;
  }

  a {
    color: rgba(0, 0, 0, 0.87);
    text-decoration: none;
    font-size: 13px;
    font-weight: 500;
  }
}
.sidechild {
  padding-left: 32px;
}
.sidechild a {
  color: #333333;
  text-decoration: none;
  font-size: 13px;
}
</style>
